import { useState } from "react";
import { toast } from "sonner";

/**
 * Shared drag-and-drop reorder logic for admin lists that are scoped by a
 * category/filter (packages per category, gallery photos per category).
 * Optimistically reorders the filtered slice, persists via `reorderRequest`,
 * and rolls back (re-fetches) on failure.
 */
export const useDragReorder = ({ filteredItems, setAllItems, filterKey, filterValue, reorderRequest, reload }) => {
  const [dragIdx, setDragIdx] = useState(null);

  const onDragStart = (idx) => setDragIdx(idx);
  const onDragOver = (e) => e.preventDefault();

  const onDrop = async (idx) => {
    if (dragIdx === null || dragIdx === idx) return;
    const reordered = [...filteredItems];
    const [moved] = reordered.splice(dragIdx, 1);
    reordered.splice(idx, 0, moved);
    setDragIdx(null);
    setAllItems((all) => [...all.filter((item) => item[filterKey] !== filterValue), ...reordered]);
    try {
      await reorderRequest(reordered.map((item) => item.id));
    } catch {
      toast.error("Error al reordenar");
      reload();
    }
  };

  return { dragIdx, onDragStart, onDragOver, onDrop };
};
